import Printt from "@/components/print";
import printJS from 'print-js';


export let mixinPrint = {
  data() {
    return {
      printData: [],
    };
  },
  components: {
    Printt
  },
  mounted() {
  },
  methods: {
    handlePrintRow(row) {
      const rowIndex = this.tableData.indexOf(row);
      const $table = this.$refs.table.$el;
      const $rows = $table.querySelectorAll('.el-table__body-wrapper tbody tr');

      // 获取表格列信息
      const table = this.$refs.table;
      const columns = table.cloumns.filter(cloumn => cloumn.attrs.type != "selection" && cloumn.attrs.label !== '操作' && cloumn.attrs.type !== 'index');
      // .map(item => ({ prop: item.attrs.prop, label: item.attrs.label }))

      this.printData = columns.map((col, index) => {
        const attrs = col.attrs;
        let format_str = ''
        if (attrs.formatter) {
          const arrName = attrs['labelClassName'] || attrs['label-class-name']
          this.$store.state[arrName].map((item, i) => {
            if (row[attrs.prop] == item.value) {
              format_str = item.label
            }
          })
        }
        return {
          label: attrs.label,
          value: format_str?format_str:this.getValue(row, attrs.prop)
        }
      });
      this.$nextTick(() => {
        this.$refs.printt.setPrintHtml((this.$refs.pageHeader && this.$refs.pageHeader.innerText) ? this.$refs.pageHeader.innerText : '');
        this.printJS()
      })
    },
    getValue(obj, path, defaultValue = '') {
      if (!obj || !path) return defaultValue;

      // 支持路径为数组或字符串
      const keys = Array.isArray(path) ? path : path.split('.');

      // 使用 reduce 遍历路径
      const result = keys.reduce((acc, key) => {
        return acc?.[key];
      }, obj);

      // 返回结果或默认值
      return result !== undefined ? result : defaultValue;
    },
    printJS() {
      this.$nextTick(() => {
        printJS('printArea', 'html')
      })
    }
  }
};
